import React, { FocusEventHandler } from "react"
import { ClienteData, ClienteDto } from "../../generated"
import { Autocomplete } from "../../common/components/autocompleteInput"
import Actions, { CustomersFilterData } from "../customersActions";
import { formGroup } from "../../common/components/formGroup";
import OpenModalButton from "../../common/components/openModalButton";
import CustomerFormLight from "./CustomerFormLight";
import { ComuneDescription } from "../../comuni/components/ComuneData";
import { SaveOrUpdateCustomer } from "./customerEdit";

interface Props {
    error?: string;
    onChange: (comune: ClienteDto | null) => void;
    hidden?: boolean;
    name?: string;
    placeholder?: string;
    label?: string;
    style?: React.CSSProperties;
    readOnly?: boolean;
    value?: ClienteDto | number;
    required?: boolean;
    onFocus?: FocusEventHandler;
    onBlur?: FocusEventHandler;
}

export const CustomersAutocomplete = formGroup((props: Props) => {
    const modal = React.useRef<OpenModalButton>(null);
    var component = (
        <Autocomplete
            style={props.style}
            name={props.name}
            label={props.label || "Cliente"}
            error={props.error}
            onChange={props.onChange}
            textSelector={x => `${x.cognomeProprietario} ${x.nomeProprietario} ${x.responsabile && `(${x.responsabile})` || ""}`}
            idSelector={x => x.idCliente}
            required={props.required}
            onBlur={props.onBlur}
            onFocus={props.onFocus}
            value={typeof props.value == "number" ? props.value.toString() : props.value?.idCliente.toString()}
            readOnly={props.readOnly}
            ActionsGet={id => Actions.getCliente(+id)}
            itemComponent={cliente => <div>
                <div className="fw-bold">{cliente.cognomeProprietario} {cliente.nomeProprietario}</div>
                <small>{cliente.comune && <ComuneDescription codFisComune={cliente.comune.codFisComune} />} {cliente.indirizzo}</small>
            </div>}
            ActionsSearch={literal => {
                const filterData = new CustomersFilterData;
                filterData.filtroNominativo = literal;
                return Actions.submitFilter(filterData).then(({ result }) => result!)
            }}
        >
            {props.value == null && <OpenModalButton
                ref={modal}
                className="btn btn-secondary"
                title="Aggiungi cliente"
                modalContent={
                    <CustomerFormLight
                        customer={new ClienteData()}
                        onCancel={() => modal?.current?.close()}
                        onSubmit={async customer => {
                            const c = await SaveOrUpdateCustomer(customer)
                            modal?.current?.close()
                            if (c != null)
                                props.onChange(c);
                        }}
                    />
                } >
                <div className="text-nowrap"><i className="fas fa-user-plus" /> Nuovo</div>
            </OpenModalButton>}
        </Autocomplete >
    );
    if (props.hidden === true) {
        component = (<div />);
    }
    return (component);
})
